"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStudentsSummary = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var Icon_1 = require("../Icon/Icon");
var context_1 = require("../../../api/context");
var DpSectionCard_1 = require("../Cards/DpSectionCard");
var DpStudentsSummary_styled_1 = require("./DpStudentsSummary.styled");
var DpUnattemptedStudentModal_1 = require("../UnattemptedStudentModal/DpUnattemptedStudentModal");
var AtomicAlertManagerContext_1 = require("../AtomicAlert/AtomicAlertManagerContext");
var DpStudentsSummary = function (_a) {
    var assessment = _a.assessment, classes = _a.classes;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // --------------------------- Context
    var summaryService = (0, react_1.useContext)(context_1.ServiceContext).summaryService;
    var toast = (0, react_1.useContext)(AtomicAlertManagerContext_1.AtomicAlertManagerContext).toast;
    // --------------------------- State
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)(null), assessmentCompletionSummary = _c[0], setAssessmentCompletionSummary = _c[1];
    var _d = (0, react_1.useState)(false), showUnattemptedStudentModal = _d[0], setShowUnattemptedStudentModal = _d[1];
    // ----------------------------------------- Methods
    var fetchCompletionSummary = (0, react_1.useCallback)(function () {
        summaryService
            .getAssessmentCompletionSummaryByClassAndAssessmentAndTemplate(classes, assessment, assessment.assessmentTemplate)
            .then(function (assessmentCompletion) {
            setAssessmentCompletionSummary(assessmentCompletion);
            setInitialized(true);
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.studentSummary'),
                },
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assessment, classes, summaryService]);
    (0, react_1.useEffect)(function () {
        if (classes) {
            fetchCompletionSummary();
        }
    }, [classes, fetchCompletionSummary]);
    var openUnattemptedStudentModal = function () {
        setShowUnattemptedStudentModal(true);
    };
    var closeModal = function () {
        setShowUnattemptedStudentModal(false);
    };
    return (initialized && ((0, jsx_runtime_1.jsx)(DpStudentsSummary_styled_1.StyledStudentsSummary, { "data-testid": "students-summary", children: (0, jsx_runtime_1.jsxs)(DpSectionCard_1.DpSectionCard, { title: t('studentsSummary.title'), children: [(0, jsx_runtime_1.jsxs)("div", { className: "summary", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h2", { className: "submitted", children: assessmentCompletionSummary.submitted }), (0, jsx_runtime_1.jsx)("p", { children: t('studentsSummary.students') })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h2", { className: "unattempted", children: assessmentCompletionSummary.unattempted }), (0, jsx_runtime_1.jsx)("p", { children: t('studentsSummary.unattemptedStudents') })] })] }), (0, jsx_runtime_1.jsx)("div", { children: assessmentCompletionSummary.unattempted > 0 && ((0, jsx_runtime_1.jsx)("h2", { className: "see-students", onClick: openUnattemptedStudentModal, children: t('studentsSummary.seeStudents') })) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "footer d-none", children: [(0, jsx_runtime_1.jsx)("a", { href: "/", children: t('studentsSummary.reschedule') }), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "arrow-front" })] }), showUnattemptedStudentModal && ((0, jsx_runtime_1.jsx)(DpUnattemptedStudentModal_1.DpUnattemptedStudentModal, { show: true, assessment: assessment, closeHandler: closeModal }))] }) })));
};
exports.DpStudentsSummary = DpStudentsSummary;
exports.default = exports.DpStudentsSummary;
